//simplemaps_custommap.hooks.ready = function ()
//{
//    simplemaps_custommap.load();
//    send_map_data(null, null);


//};

simplemaps_custommap.hooks.zoomable_click_state = function (id)
{

    document.getElementById('hdnCurrentCountyId').value = id;

    if (simplemaps_custommap_mapinfo.mappings[id])
    {
        var countyId = simplemaps_custommap_mapinfo.mappings[id].id;

        sessionStorage.setItem("search-by-location-countyLastClickedId", id);

        CurrentCountyId = countyId;
        CurrentDistrictId = false;
        CurrentPageNumber = 1;
        pageEntry = false;

        for (var stateId in simplemaps_custommap_mapinfo.mappings[id].states)
        {
            simplemaps_custommap.states[simplemaps_custommap.mapinfo.mappings[id].states[stateId]].show();
        }

        update_school_list(countyId, id, false, false);

        if (simplemaps_custommap_mapinfo.districts[simplemaps_custommap.zoom_level_id])
        {
            simplemaps_custommap_mapdata.locations = simplemaps_custommap_mapdata.default_locations;
            simplemaps_custommap.refresh_locations();
        }

        if (simplemaps_custommap.zoom_level == "state")
        {
            simplemaps_custommap.states[simplemaps_custommap.zoom_level_id].attr(simplemaps_custommap.states[simplemaps_custommap.zoom_level_id].sm.attributes);
        }
    } else if (simplemaps_custommap_mapinfo.districts[id])
    {
        sessionStorage.setItem("search-by-location-districtLastClickedId", id);

        //Promise.resolve(simplemaps_custommap.click_path).then(function ()
        //{
        //    sessionStorage.setItem("search-by-location-districtClickPath", simplemaps_custommap.click_path[1].sm);
        //});

        CurrentCountyId = false;
        CurrentDistrictId = id;
        CurrentPageNumber = 1;
        pageEntry = false;


        var districtId = simplemaps_custommap_mapdata.state_specific[id].id;
        update_school_list(false, false, districtId, id);

        simplemaps_custommap_mapdata.locations = offsetAllLocations(simplemaps_custommap_mapinfo.districts[id].locations);
        
        simplemaps_custommap.refresh_locations();
    }
};

simplemaps_custommap.hooks.back = function ()
{
    back();
};

simplemaps_custommap.hooks.click_location = function (id)
{
    var schoolId = id ? parseInt(id) : null;
    window.objRef.invokeMethodAsync('LocationClicked', schoolId)
        .catch(() =>
            console.log("Location click failed.")
        );
    
};

simplemaps_custommap.hooks.zooming_complete = function ()
{
    if (simplemaps_custommap.zoom_level == "state")
    {
        if (simplemaps_custommap_mapinfo.mappings[simplemaps_custommap.zoom_level_id])
        {
            var countyId = simplemaps_custommap_mapinfo.mappings[simplemaps_custommap.zoom_level_id].id;
            console.log('you clicked countyId ' + countyId);
        } else if (simplemaps_custommap.zoom_level == "state")
        {
            console.log('you clicked district organizationId ' + simplemaps_custommap.zoom_level_id);
        }
    }
};

window.simplemapLink = {

    resetMap: () =>
    {
        if (window.currentSchoolOriginal)
        {
            window.currentSchoolOriginal.dispatchEvent(new Event("mouseout", { bubbles: true }));
            window.currentSchoolOriginal = null;
        }

        reset_map();
        setTimeout(() =>
        {
            simplemaps_custommap.pulse('9000');
        }, 1000);
    }
}
function reset_map()
{
    sessionStorage.setItem("search-by-location-countyLastClickedId", -1);
    sessionStorage.setItem("search-by-location-districtLastClickedId", -1);

    var element;
    var index = simplemaps_custommap.click_path.length;
    do
    {
        index = index - 1;

        if (index < 0)
            element = simplemaps_custommap.regions[-1];
        else
            element = simplemaps_custommap.click_path[index];

        if (element.sm.type == "state")
        {
            element.attr(simplemaps_custommap.states[element.sm.id].sm.attributes);
        }
    } while (element != simplemaps_custommap.regions[-1]);

    CurrentCountyId = false;
    CurrentDistrictId = false;
    CurrentPageNumber = 1;

    for (var stateId in simplemaps_custommap.states)
    {
        if (simplemaps_custommap.states[stateId].sm.id < 1000)
        {
            simplemaps_custommap.states[stateId].hide();
        } else
        {
            simplemaps_custommap.states[stateId].show();
        }
    }
    simplemaps_custommap.reset_map();
    simplemaps_custommap.region_zoom("-1");
    update_school_list(false, false, false, false);
}

function update_school_list(countyId, countyMapId, districtId, districtMapId)
{

    districtId = districtId ? parseInt(districtId) : null;
    countyId = countyId ? parseInt(countyId) : null;
    districtMapId = districtMapId ? parseInt(districtMapId) : null;
    countyMapId = countyMapId ? parseInt(countyMapId) : null;


    window.objRef.invokeMethodAsync('UpdateSchoolList', districtId, countyId, districtMapId, countyMapId)
        .catch(() =>
            console.log("UpdateSchoolList failed.")
    );

    //send_map_data(countyId, districtId);
    
}
function return_map_load()
{
    var districtLastClickedId = sessionStorage.getItem("search-by-location-districtLastClickedId");
    var countyLastClickedId = sessionStorage.getItem("search-by-location-countyLastClickedId");

    if (districtLastClickedId > 0)
    {
        if (pageEntry)
        {
            pageEntry = false;
            document.getElementById('hdnCurrentCountyId').value = districtLastClickedId;

            if (simplemaps_custommap_mapinfo.mappings[countyLastClickedId])
            {
                var countyId = countyLastClickedId.id;

                CurrentCountyId = countyId;
                CurrentDistrictId = districtLastClickedId;
                CurrentPageNumber = 1;

                for (var stateId in simplemaps_custommap_mapinfo.mappings[countyLastClickedId].states)
                {
                    simplemaps_custommap.states[simplemaps_custommap.mapinfo.mappings[countyLastClickedId].states[stateId]].show();
                }

                if (simplemaps_custommap_mapinfo.districts[simplemaps_custommap.zoom_level_id])
                {
                    simplemaps_custommap_mapdata.locations = simplemaps_custommap_mapdata.default_locations;
                    simplemaps_custommap.refresh_locations();
                }

                if (simplemaps_custommap.zoom_level == "state")
                {
                    simplemaps_custommap.states[simplemaps_custommap.zoom_level_id].attr(simplemaps_custommap.states[simplemaps_custommap.zoom_level_id].sm.attributes);
                }
            }

            simplemaps_custommap.state_zoom(countyLastClickedId);
            var district = simplemaps_custommap_mapinfo.districts[districtLastClickedId];
            simplemaps_custommap.state_zoom(districtLastClickedId);

            update_school_list(false, false, districtLastClickedId, district.id);

            simplemaps_custommap_mapdata.locations = district.locations;
            simplemaps_custommap.refresh_locations();
        }
    } else if (countyLastClickedId > 0)
    {
        if (pageEntry)
        {
            pageEntry = false;

            simplemaps_custommap.hooks.zoomable_click_state(countyLastClickedId);

            simplemaps_custommap.state_zoom(countyLastClickedId);
        }
    }
}

function offsetAllLocations(locations, offsetDistance = 0.010)
{
    let locationArray = Object.values(locations); // Convert object to array

    locationArray.forEach(loc =>
    {
        let angle = Math.random() * Math.PI * 2; // Random angle (0 to 360 degrees)
        let distance = offsetDistance * (Math.random() + 0.5); // Random distance (0.5x to 1.5x offsetDistance)

        loc.lat += Math.sin(angle) * distance;
        loc.lng += Math.cos(angle) * distance;
    });

    // Reassign updated locations back to the object
    Object.keys(locations).forEach((key, index) =>
    {
        locations[key] = locationArray[index];
    });

    return locations;
}

function back()
{
    var districtLastClickedId = sessionStorage.getItem("search-by-location-districtLastClickedId");
    var countyLastClickedId = sessionStorage.getItem("search-by-location-countyLastClickedId");

    simplemaps_custommap.states[simplemaps_custommap.zoom_level_id].attr(simplemaps_custommap.states[simplemaps_custommap.zoom_level_id].sm.attributes);

    var element;
    var index = simplemaps_custommap.click_path.length;
    do
    {
        index = index - 1;
        if (index < 0)
            element = simplemaps_custommap.regions[-1];
        else
            element = simplemaps_custommap.click_path[index];
    } while (element.sm.id == simplemaps_custommap.zoom_level_id && element != simplemaps_custommap.regions[-1]);

    var args = {};

    if (element.sm.type == "out")
    {
        CurrentCountyId = false;
        CurrentDistrictId = false;
        CurrentPageNumber = 1;

        for (var stateId in simplemaps_custommap.states)
        {
            if (simplemaps_custommap.states[stateId].sm.id < 1000)
            {
                simplemaps_custommap.states[stateId].hide();
                districtLastClickedId = -1;
                sessionStorage.setItem("search-by-location-districtLastClickedId", -1);
            } else
            {
                simplemaps_custommap.states[stateId].show();
                districtLastClickedId = -1;
                countyLastClickedId = -1;
                sessionStorage.setItem("search-by-location-countyLastClickedId", -1);
                sessionStorage.setItem("search-by-location-districtLastClickedId", -1);
            }
        }
        update_school_list(false, false, false, false);
    } else if (element.sm.type == "state" && simplemaps_custommap_mapinfo.mappings[element.sm.id])
    {
        var countyId = simplemaps_custommap_mapinfo.mappings[element.sm.id].id;

        CurrentCountyId = countyId;
        CurrentDistrictId = false;
        CurrentPageNumber = 1;

        districtLastClickedId = -1;
        sessionStorage.setItem("search-by-location-districtLastClickedId", -1);

        update_school_list(countyId, element.sm.id, false, false);
    } else
    {
        var districtId = simplemaps_custommap_mapdata.state_specific[element.sm.id].id;

        CurrentCountyId = false;
        CurrentDistrictId = districtId;
        CurrentPageNumber = 1;

        countyLastClickedId = -1;
        districtLastClickedId = -1;
        sessionStorage.setItem("search-by-location-countyLastClickedId", -1);
        sessionStorage.setItem("search-by-location-districtLastClickedId", -1);

        update_school_list(false, false, districtId, element.sm.id);
    }

}